module.exports = __webpack_public_path__ + "static/media/XCircle.f72a6b25.svg";